<template>
  <div>
    <div class="warp">
      <div class="left" v-if="flag">
        <div class="circle">
          <img @click="sc('bsl')" class="img1" alt="" src="../assets/img/appointment.png">
        </div>
        <p class="p1">伯思立院区</p>
      </div>
      <div class="left" v-if="flag">
        <div class="circle">
          <img @click="sc('fls')" class="img1" alt="" src="../assets/img/appointment.png">
        </div>
        <p class="p1">翡立思院区</p>
      </div>
      <div class="left" v-if="flag">
        <div class="circle">
          <img @click="sc('ntbsl')" class="img1" alt="" src="../assets/img/appointment.png">
        </div>
        <p class="p1">南通伯思立</p>
      </div>
      <div class="left" v-if="flag">
        <div class="circle">
          <img @click="sc('bjbsl')" class="img1" alt="" src="../assets/img/appointment.png">
        </div>
        <p class="p1">北京百达丽</p>
      </div>
      <div class="left" v-if="flag">
        <div class="circle">
          <img @click="sc('wzbsl')" class="img1" alt="" src="../assets/img/appointment.png">
        </div>
        <p class="p1">温州伯思立</p>
      </div>
      <div class="left" v-if="scan">
        <div class="circle">
          <img @click="cy" class="img2" alt="" src="../assets/img/part.png">
        </div>
        <p class="p2">扫码管理</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "system",
  data() {
    return {
      systemType: Lockr.get('systemType'),
      flag: true,
      scan: true,
      cityCode: Lockr.get("cityCode")
    }
  },
  created() {
    if (this.systemType.indexOf('2') != -1 && this.systemType.indexOf('1') != -1) {
      this.flag = true
      this.scan = true
    } else {
      this.flag = true
      this.scan = false
    }
  },
  methods: {
    sc(val) {
      // cityCode：1上海，2南通，3北京4温州
      if (this.cityCode == '1' && (val == 'ntbsl' || val == 'bjbsl' || val == 'wzbsl')) {
        _g.toast('warning', '此账号没有权限')
      } else if (this.cityCode == '2' && (val == 'bsl' || val == 'fls' || val == 'bjbsl' || val == 'wzbsl')) {
        _g.toast('warning', '此账号没有权限')
      } else if (this.cityCode == '3' && (val == 'bsl' || val == 'fls' || val == 'ntbsl' || val == 'wzbsl')) {
        _g.toast('warning', '此账号没有权限')
      } else if (this.cityCode == '4' && (val == 'bsl' || val == 'fls' || val == 'ntbsl' || val == 'bjbsl')) {
        _g.toast('warning', '此账号没有权限')
      } else {
        router.push('/')
        Lockr.set('areaType', val)
      }
    },
    cy() {
      router.push('/')
    },
  }
}
</script>

<style scoped>
.warp {
  padding-top: 20%;
  display: flex;
}
.left {
  margin: 0 auto;
  text-align: center;
  cursor: pointer;
}
.circle {
  border-radius: 30%;
  width: 100px;
  height: 100px;
  background: #379aee;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img1 {
  display: block;
  width: 80px;
  height: 80px;
}
.img2 {
  display: block;
  width: 80px;
  height: 80px;
}
</style>
